/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {EventEmitter, Injectable} from '@angular/core';
import {TableLineComponent} from '../table-line/table-line.component';
import {Observable, Subject} from 'rxjs';
import {TableLineHeightModel} from '../models/table-line-height.model';
import {TableLineAvailableActionsModel} from '../models/table-line-available-actions.model';

@Injectable({
    providedIn: 'root'
})
export class TableService<Enum, DataObject> {
    public readonly openEvent = new EventEmitter<TableLineComponent<Enum, DataObject>>();
    private availableAction = new Subject<TableLineAvailableActionsModel>();
    private openLineHeight = new Subject<TableLineHeightModel>();

    getOpenLineHeightValue(): Observable<TableLineHeightModel> {
         return this.openLineHeight?.asObservable();
    }

    setOpenLineHeightValue(newValue: TableLineHeightModel): void {
        if (newValue?.identifier != null) {
            newValue.identifier = `id-${newValue.identifier}`;
        }
        this.openLineHeight?.next(newValue);
    }

    getAvailableActionValue(): Observable<TableLineAvailableActionsModel> {
        return this.availableAction?.asObservable();
    }

    setAvailableActionValue(newValue: TableLineAvailableActionsModel): void {
        this.availableAction?.next(newValue);
    }
}
